// extracted by mini-css-extract-plugin
export default {"wrapper":"ClientsImportInProgress--wrapper--675622","title":"ClientsImportInProgress--title--cc5a22"};